import React from 'react';
import styled from 'styled-components';

const PostCountWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 40px 0;
  padding: 0 18px;

  & > div {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.3em;
    font-family: 'Inter';
  }
`;
const Circle = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 50%;

  border: 2px solid #fff;
`;

const PositiveCircle = styled(Circle)`
  background: rgba(3, 198, 82, 1);
`;

const NeutralCircle = styled(Circle)`
  background: rgba(239, 205, 29, 1);
`;

const NegativeCircle = styled(Circle)`
  background: rgba(238, 19, 7, 1);
`;

const sentimentLabels = {
    positive: {
        instagram: 'Total Positive Comments -',
        youtube: 'Total Positive Comments -',
        facebook: 'Total Positive Posts -',
        default: 'Total Positive Reposts -',
        icon: <PositiveCircle />,
    },
    negative: {
        instagram: 'Total Negative Comments -',
        youtube: 'Total Negative Comments -',
        facebook: 'Total Negative Posts -',
        default: 'Total Negative Reposts -',
        icon: <NegativeCircle />,
    },
    neutral: {
        instagram: 'Total Neutral Comments -',
        youtube: 'Total Neutral Comments -',
        facebook: 'Total Neutral Posts -',
        default: 'Total Neutral Reposts -',
        icon: <NeutralCircle />,
    },
};

const getSentimentLabel = (sentiment, channel) => {
    return (
        sentimentLabels[sentiment][channel] || sentimentLabels[sentiment].default
    );
};

const getSentimentCount = (sentiment, channel, filteredData, sentiments_tab) => {
    const source = filteredData || sentiments_tab || {};
    const isPostBased = ['instagram', 'facebook', 'youtube'].includes(channel);

    const key = `total_${sentiment}_posts`;
    return isPostBased
        ? source?.top_posts?.[key] || 0
        : source?.top_reposts?.[key] || 0;
};

const SentimentPostCount = ({ channel, filteredData, sentiments_tab }) => {
    if (channel === 'instagram' || channel === 'facebook') return null;

    return (
        <PostCountWrapper>
            {['positive', 'negative', 'neutral'].map((sentiment) => (
                <div style={{ color: '#292A2A' }}>
                    <div key={sentiment} style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                        {sentimentLabels[sentiment].icon}
                        {getSentimentLabel(sentiment, channel)}
                        {getSentimentCount(sentiment, channel, filteredData, sentiments_tab)}
                    </div>
                </div>
            ))}
            
        </PostCountWrapper>

    );
};

export default SentimentPostCount;
